<template>
  <div class="common-box">
    <el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
      label-width="90px">
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="卡号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.cardCode" placeholder="请输入卡号"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="名称：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.cardName" placeholder="请输入名称"
              clearable></el-input>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button size="mini" type="primary" class="plr28" @click="handleDelete" plain>删除
        </el-button>
      </div>
      <div class="table__container">
        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cardCode" label="卡号" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cardName" label="名称" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
          <el-table-column show-overflow-tooltip prop="balance" label="余额" ></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <div class="btn-divide"></div>
              <el-button size="mini" type="text" @click="handleDeleteCause(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <add-cause v-if="addCauseVisible" @cancel="addCauseVisible = false" @confirm="handleAddCauseConfirm"></add-cause>
    <edit-cause v-if="editCauseVisible" :detail="causeDetail" @cancel="editCauseVisible = false"
      @confirm="handleEditCauseConfirm"></edit-cause>
  </div>
</template>

<script>
  import {
    getCardPageList,
    deleteCard
  } from '@/api/Card'

  import AddCause from './components/AddCause'
  import EditCause from './components/EditCause'
  export default {
    name: 'MaterialInfo',
    components: {
      AddCause,
      EditCause,
    },
    data() {
      return {
        form: {
          createTimeBetween: null,
          payableNo: ""
        },
        tableLoading: false,
        list: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        addCauseVisible: false,
        editCauseVisible: false,
        checkDepartment: false,
        causeDetail: {},
        spendingList: []
      }
    },
    computed: {
      hasRole: function() {
        return this.$store.getters['common/promise/getRole'](this.$route.path);
      }
    },
    created() {
      this.getListData();
    },
    methods: {
      async getListData() {
        this.tableLoading = true
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        if (this.form.createTimeBetween) {
          delete params.createTimeBetween;
          params.billDateEnd = this.form.createTimeBetween[1];
          params.billDateStart = this.form.createTimeBetween[0];
        }
        const res = await getCardPageList(params)
        if (res.code === 200) {
          this.total = res.data.total
          this.list = res.data.list
        }
        this.tableLoading = false
      },
      handleSearch() {
        this.pageIndex = 1
        this.getListData()
      },
      handleRefresh() {
        for (let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = []
          } else {
            this.form[key] = ''
          }
        }
        this.pageIndex = 1
        this.getListData()
      },
      handleSearchListData() {
        this.pageIndex = 1
        this.getListData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      handleDeleteCause(row) {
        const idList = [row.id]
        this.deleteCause(idList)
      },
      handleCheck(row) {
        this.causeDetail = row
        this.checkDepartment = true
      },
      handleEdit(row) {
        this.causeDetail = row
        this.editCauseVisible = true
      },
      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning('请选择要删除的行')
          return
        }
        const idList = this.multipleSelection.map(item => item.id)
        this.deleteCard(idList)
      },
      deleteCard(idList) {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await deleteCard({
            idList
          })
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getListData()
          }
        }).catch((err) => {
          console.log(err)
        })

      },
      handleAdd() {
        this.addCauseVisible = true
      },
      exportCause() {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        exportCause(params)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.getListData()
      },
      handleAddCauseConfirm() {
        this.addCauseVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      handleEditCauseConfirm() {
        this.editCauseVisible = false
        this.getListData()
      },

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/CardManagement/CardManagement.vue